export const calendarAvailabilityConstants = {
  // create calendar Availability
  CREATE_CALENDAR_AVAILABILITY_ACTION_REQUEST:
    "CREATE_CALENDAR_AVAILABILITY_ACTION_REQUEST",
  CREATE_CALENDAR_AVAILABILITY_ACTION_SUCCESS:
    "CREATE_CALENDAR_AVAILABILITY_ACTION_SUCCESS",
  CREATE_CALENDAR_AVAILABILITY_ACTION_FAILURE:
    "CREATE_CALENDAR_AVAILABILITY_ACTION_FAILURE",

  // update calendar Availability
  UPDATE_CALENDAR_AVAILABILITY_ACTION_REQUEST:
    "UPDATE_CALENDAR_AVAILABILITY_ACTION_REQUEST",
  UPDATE_CALENDAR_AVAILABILITY_ACTION_SUCCESS:
    "UPDATE_CALENDAR_AVAILABILITY_ACTION_SUCCESS",
  UPDATE_CALENDAR_AVAILABILITY_ACTION_FAILURE:
    "UPDATE_CALENDAR_AVAILABILITY_ACTION_FAILURE",

  // delete calendar Availability
  DELETE_CALENDAR_AVAILABILITY_ACTION_REQUEST:
    "DELETE_CALENDAR_AVAILABILITY_ACTION_REQUEST",
  DELETE_CALENDAR_AVAILABILITY_ACTION_SUCCESS:
    "DELETE_CALENDAR_AVAILABILITY_ACTION_SUCCESS",
  DELETE_CALENDAR_AVAILABILITY_ACTION_FAILURE:
    "DELETE_CALENDAR_AVAILABILITY_ACTION_FAILURE",

  // get calendar Availability details
  GET_CALENDAR_AVAILABILITY_DETAILS_ACTION_REQUEST:
    "GET_CALENDAR_AVAILABILITY_DETAILS_ACTION_REQUEST",
  GET_CALENDAR_AVAILABILITY_DETAILS_ACTION_SUCCESS:
    "GET_CALENDAR_AVAILABILITY_DETAILS_ACTION_SUCCESS",
  GET_CALENDAR_AVAILABILITY_DETAILS_ACTION_FAILURE:
    "GET_CALENDAR_AVAILABILITY_DETAILS_ACTION_FAILURE",

  // get calendar Availability lists
  GET_CALENDAR_AVAILABILITY_LISTS_ACTION_REQUEST:
    "GET_CALENDAR_AVAILABILITY_LISTS_ACTION_REQUEST",
  GET_CALENDAR_AVAILABILITY_LISTS_ACTION_SUCCESS:
    "GET_CALENDAR_AVAILABILITY_LISTS_ACTION_SUCCESS",
  GET_CALENDAR_AVAILABILITY_LISTS_ACTION_FAILURE:
    "GET_CALENDAR_AVAILABILITY_LISTS_ACTION_FAILURE",

  // get availability
  GET_CALENDAR_AVAILABILITY_ACTION_REQUEST:
    "GET_CALENDAR_AVAILABILITY_ACTION_REQUEST",
  GET_CALENDAR_AVAILABILITY_ACTION_SUCCESS:
    "GET_CALENDAR_AVAILABILITY_ACTION_SUCCESS",
  GET_CALENDAR_AVAILABILITY_ACTION_FAILURE:
    "GET_CALENDAR_AVAILABILITY_ACTION_FAILURE",

  // update calendar Availability availability
  UPDATE_CALENDAR_EVENT_AVAILABILITY_ACTION_REQUEST:
    "UPDATE_CALENDAR_EVENT_AVAILABILITY_ACTION_REQUEST",
  UPDATE_CALENDAR_EVENT_AVAILABILITY_ACTION_SUCCESS:
    "UPDATE_CALENDAR_EVENT_AVAILABILITY_ACTION_SUCCESS",
  UPDATE_CALENDAR_EVENT_AVAILABILITY_ACTION_FAILURE:
    "UPDATE_CALENDAR_EVENT_AVAILABILITY_ACTION_FAILURE",
};
